import { BusinessUnitModalProps } from '..';
import { BusinessUnitRow } from '../../list';
import { BUSINESS_UNIT_VALUES } from './constants';
import { BusinessUnitValues } from './types';

type DefaultValueProps = {
  existingBusinessUnit: BusinessUnitRow;
};
export const getDefaultValues = (props: DefaultValueProps) => {
  const { existingBusinessUnit } = { ...props };

  const {
    __typename,
    id,
    _isUpdatable,
    _isDeletable,
    _rowTimestamp,
    chartOfAccount,
    companyChartOfAccount,
    companyAddressesByCompanyIdAndEntityId,
    companyBusinessUnitCurrencies,
    ...businessUnitFields
  } = {
    ...existingBusinessUnit,
  };
  const { nodes } = { ...companyAddressesByCompanyIdAndEntityId };
  let defaultValues: BusinessUnitValues = BUSINESS_UNIT_VALUES;
  if (!!id) {
    const currencies =
      companyBusinessUnitCurrencies?.nodes?.map(
        ({ companyCurrency, ...currencyField }) => ({ ...currencyField })
      ) || [];
    defaultValues = {
      ...businessUnitFields,
      companyAddressesByCompanyIdAndEntityId: !!nodes.length ? [...nodes] : [],
      companyBusinessUnitCurrencies: !!currencies.length ? currencies : [],
    };
  }
  return defaultValues;
};
